import { ApolloProvider } from '@apollo/client';
import { graphqlClient } from './client';
import React from 'react';
const GraphQLClientProvider = ({ children }) => {
    return React.createElement(ApolloProvider, { client: graphqlClient }, children);
};
export default GraphQLClientProvider;
